import { useAtomValue } from "jotai";
import { useMemo } from "react";

import { $workspaces } from "../../internal/workspaces";
import { useRouteParams } from "./useRouteParams";

export const useWorkspaceFromCurrentRoute = () => {
	const { workspaceName } = useRouteParams();
	const workspaces = useAtomValue($workspaces);

	const workspace = useMemo(() => {
		if (!workspaceName) {
			return;
		}

		// FIXME: Is this correct? It might be indexed by ID and not name
		return workspaces.data[workspaceName];
	}, [workspaces, workspaceName]);

	return {
		workspaceName,
		workspace,
	};
};
